import { AxiosResponse } from "axios";
import { request } from "@utils";
import { GateRead } from "@types";

export const getAllGates = (): Promise<AxiosResponse<GateRead[]>> => {
  const req = request();
  return req.get("/api/v1/gates");
};
